module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              _vm.showKontaktNeu = true
            }
          }
        }, on), [_c('v-icon', [_vm._v("add")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Erstellen")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticClass: "hidden-sm-and-down",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              _vm.showMehrereBearbeiten = true
            }
          }
        }, on), [_c('v-icon', [_vm._v("edit_note")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Auswahl bearbeiten")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticClass: "hidden-sm-and-down",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.showImportExport = !_vm.showImportExport
            }
          }
        }, on), [_c('v-icon', [_vm._v("cloud_upload")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Daten importieren")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticClass: "hidden-sm-and-down",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.exportData()
            }
          }
        }, on), [_c('v-icon', [_vm._v("cloud_download")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Daten exportieren")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              _vm.showPrintDialog = true;
              _vm.printData = {};
            }
          }
        }, on), [_c('v-icon', [_vm._v("print")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Drucken")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticClass: "hidden-sm-and-down",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              _vm.showAenderungen = true
            }
          }
        }, on), [_c('v-icon', [_vm._v("manage_accounts")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Kontaktänderungen")])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticClass: "hidden-sm-and-down",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              _vm.showFilterSpalten = true
            }
          }
        }, on), [_c('v-icon', [_vm._v("tune")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Spalten")])]), _vm._v(" "), _c('v-toolbar-items', [_c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Suchen",
      "single-line": "",
      "solo": "",
      "flat": "",
      "hide-details": "",
      "clearable": "",
      "clear-icon": "close"
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.showImportExport) ? _c('dialogImportKontakte', {
    attrs: {
      "visible": _vm.showImportExport
    },
    on: {
      "close": function($event) {
        _vm.showImportExport = false
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('v-navigation-drawer', {
    attrs: {
      "v-model": _vm.showVarGruppenLeiste,
      "app": "",
      "right": "",
      "clipped": _vm.$vuetify.breakpoint.lgAndUp,
      "mini-variant": _vm.showGruppenLeiste
    },
    on: {
      "update:miniVariant": function($event) {
        _vm.showGruppenLeiste = $event
      },
      "update:mini-variant": function($event) {
        _vm.showGruppenLeiste = $event
      }
    }
  }, [_c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-list-item', [_c('v-list-item-icon', [(_vm.showGruppenLeiste) ? _c('v-icon', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showGruppenLeiste = !_vm.showGruppenLeiste
      }
    }
  }, [_vm._v("keyboard_arrow_left")]) : _c('v-icon', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showGruppenLeiste = !_vm.showGruppenLeiste
      }
    }
  }, [_vm._v("keyboard_arrow_right")])], 1), _vm._v(" "), _c('v-list-item-title', {
    staticClass: "subtitle-1"
  }, [_vm._v("Gruppen")])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-item', {
    attrs: {
      "link": ""
    },
    on: {
      "click": function($event) {
        (_vm.selectedGruppe = null) && (_vm.selected = [])
      }
    }
  }, [_c('v-tooltip', {
    attrs: {
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-list-item-icon', _vm._g({}, on), [_c('v-icon', [_vm._v("groups")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Alle Kontakte")])]), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Alle Kontakte")])], 1)], 1), _vm._v(" "), _c('v-list-item', {
    attrs: {
      "link": ""
    },
    on: {
      "click": function($event) {
        return _vm.setSelectedGruppeBbrBbr()
      }
    }
  }, [_c('v-tooltip', {
    attrs: {
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-list-item-icon', _vm._g({}, on), [_c('v-icon', [_vm._v("groups")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Alle " + _vm._s(_vm.bezMitglieder))])]), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Alle " + _vm._s(_vm.bezMitglieder))])], 1)], 1), _vm._v(" "), _vm._l((_vm.gruppen.gruppen), function(gruppe, index) {
    return _c('v-list-group', {
      key: index,
      attrs: {
        "value": gruppe.expand
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function() {
          return [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(gruppe.titel))])], 1)]
        },
        proxy: true
      }], null, true)
    }, [_vm._v(" "), _vm._l((gruppe.gruppen), function(item, index2) {
      return _c('v-list-item', {
        key: index2,
        attrs: {
          "nav": ""
        },
        on: {
          "click": function($event) {
            (_vm.selectedGruppe = item) && (_vm.selected = [])
          }
        }
      }, [_c('v-tooltip', {
        attrs: {
          "left": ""
        },
        scopedSlots: _vm._u([{
          key: "activator",
          fn: function(ref) {
            var on = ref.on;

            return [_c('v-list-item-icon', _vm._g({}, on), [_c('v-icon', [_vm._v("group")])], 1)]
          }
        }], null, true)
      }, [_vm._v(" "), _c('span', [_vm._v(_vm._s(item.text))])]), _vm._v(" "), _c('v-list-item-title', [_vm._v(_vm._s(item.text))])], 1)
    })], 2)
  })], 2)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "ma-0 pa-0"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-data-iterator', {
    staticClass: "hidden-sm-and-up",
    attrs: {
      "dense": "",
      "height": "calc(100vh - 300px)",
      "headers": _vm.headers,
      "items": _vm.bbrbbr,
      "search": _vm.search,
      "fixed-header": "",
      "hide-default-footer": "",
      "hide-default-header": _vm.$vuetify.breakpoint.xsOnly,
      "items-per-page": -1,
      "no-data-text": "Keine Kontakte vorhanden"
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-list-item', {
          on: {
            "click": function($event) {
              (_vm.bbr = item) && (_vm.showBbr = true)
            }
          }
        }, [_c('v-list-item-content', [_c('v-list-item-title', [(item.titel) ? _c('span', {
          staticClass: "mr-1"
        }, [_vm._v(_vm._s(item.titel))]) : _vm._e(), _vm._v(_vm._s(item.nachname) + ", " + _vm._s(item.vorname) + "\n                  ")]), _vm._v(" "), _c('v-list-item-subtitle', {
          staticClass: "subtitle-2"
        }, [_vm._v("\n                    " + _vm._s(item.status) + "\n                  ")])], 1)], 1), _vm._v(" "), _c('v-divider')]
      }
    }])
  }), _vm._v(" "), _c('v-data-table', {
    staticClass: "hidden-xs-only",
    attrs: {
      "height": "calc(100vh - 300px)",
      "headers": _vm.headers,
      "items": _vm.bbrbbr,
      "search": _vm.search,
      "fixed-header": "",
      "items-per-page": 50,
      "footer-props": {
        'items-per-page-options': [50, 100, 250, -1],
        'items-per-page-text': 'Kontakte pro Seite',
      },
      "show-select": "",
      "single-select": "",
      "hide-default-header": _vm.hideHeader,
      "no-data-text": "Keine Kontakte vorhanden",
      "dense": ""
    },
    scopedSlots: _vm._u([{
      key: "footer.page-text",
      fn: function(items) {
        return [_vm._v("\n              " + _vm._s(items.pageStart) + " - " + _vm._s(items.pageStop) + " von " + _vm._s(items.itemsLength) + "\n            ")]
      }
    }, {
      key: "top",
      fn: function() {
        return [_c('v-row', {
          staticClass: "py-2 px-4",
          attrs: {
            "no-gutters": ""
          }
        }, [_c('v-col', {
          attrs: {
            "cols": "12"
          }
        }, [(_vm.selectedGruppe !== null) ? _c('span', {
          staticClass: "title"
        }, [_vm._v(_vm._s(_vm.selectedGruppe.text) + " ("), (_vm.selected.length > 0) ? _c('span', [_vm._v(_vm._s(_vm.selected.length) + "/")]) : _vm._e(), _vm._v(_vm._s(_vm.bbrbbr.length) + ")")]) : _c('span', {
          staticClass: "title"
        }, [_vm._v("Alle Kontakte ("), (_vm.selected.length > 0) ? _c('span', [_vm._v(_vm._s(_vm.selected.length) + "/")]) : _vm._e(), _vm._v(_vm._s(_vm.bbrbbr.length) + ")")])])], 1), _vm._v(" "), _c('v-divider')]
      },
      proxy: true
    }, {
      key: "header",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', {
          staticClass: "hidden-sm-and-up"
        }, [_c('th'), _vm._v(" "), _c('th', [_vm._v("Bundesbruder")]), _vm._v(" "), _c('th')])]
      }
    }, {
      key: "header.data-table-select",
      fn: function(ref) {
        var item = ref.item;

        return [_c('th', [(_vm.selected.length === 0) ? _c('v-btn', {
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.addSelect('alle')
            }
          }
        }, [_c('v-icon', [_vm._v("check_box_outline_blank")])], 1) : _vm._e(), _vm._v(" "), (_vm.selected.length !== 0 && _vm.selected.length !== _vm.bbrbbr.length) ? _c('v-btn', {
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.addSelect('alle')
            }
          }
        }, [_c('v-icon', [_vm._v("indeterminate_check_box")])], 1) : _vm._e(), _vm._v(" "), (_vm.selected.length === _vm.bbrbbr.length) ? _c('v-btn', {
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.addSelect('keine')
            }
          }
        }, [_c('v-icon', [_vm._v("check_box")])], 1) : _vm._e()], 1)]
      }
    }, {
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', {
          class: ['Ausgetreten', 'Verstorben'].indexOf(item.status) !== -1 ? 'grey--text grey lighten-4' : '',
          on: {
            "dblclick": function($event) {
              (_vm.bbr = item) && (_vm.showBbr = true)
            }
          }
        }, [(_vm.checkIndex(item.id)) ? _c('td', {
          staticClass: "pr-0",
          attrs: {
            "width": "20px"
          }
        }, [_c('v-btn', {
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.addSelect(item.id)
            }
          }
        }, [_c('v-icon', [_vm._v("check_box_outline_blank")])], 1)], 1) : _c('td', {
          staticClass: "pr-0",
          attrs: {
            "width": "20px"
          }
        }, [_c('v-btn', {
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.addSelect(item.id)
            }
          }
        }, [_c('v-icon', [_vm._v("check_box")])], 1)], 1), _vm._v(" "), _vm._l((_vm.headers), function(item2, index) {
          return _c('td', {
            key: index
          }, [(item2.item.type === 'Date') ? _c('span', [_vm._v(_vm._s(_vm.$filters.date(item[item2.value], "DD.MM.YYYY")))]) : (item2.item.type === 'Gruppen') ? _c('span', _vm._l((item[item2.value]), function(gruppe, gruppeindex) {
            return _c('v-chip', {
              key: gruppeindex,
              staticClass: "ma-1",
              attrs: {
                "label": "",
                "small": ""
              }
            }, [_vm._v(_vm._s(gruppe))])
          }), 1) : (item2.item.type === 'Leibvater') ? _c('span', [_vm._v(_vm._s(_vm.$filters.user(item[item2.value], _vm.bbrbbr2)))]) : (item2.item.type === 'Verbindung') ? _c('span', [_vm._v(_vm._s(item[item2.value]))]) : (item2.item.type === 'Verbindungen') ? _c('span', _vm._l((item[item2.value]), function(ver, verindex) {
            return _c('v-chip', {
              key: verindex,
              staticClass: "ma-1",
              attrs: {
                "label": "",
                "small": ""
              }
            }, [_vm._v(_vm._s(ver))])
          }), 1) : _c('span', [_vm._v(_vm._s(item[item2.value]))])])
        })], 2)]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), (_vm.showKontaktNeu) ? _c('dialogKontaktCreate', {
    attrs: {
      "visible": _vm.showKontaktNeu
    },
    on: {
      "update:visible": function($event) {
        _vm.showKontaktNeu = $event
      },
      "close": function($event) {
        _vm.showKontaktNeu = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showBbr) ? _c('dialogKontaktEdit', {
    attrs: {
      "visibleEdit": _vm.showBbr,
      "visible": _vm.showBbr,
      "bbr": _vm.bbr
    },
    on: {
      "update:visibleEdit": function($event) {
        _vm.showBbr = $event
      },
      "update:visible-edit": function($event) {
        _vm.showBbr = $event
      },
      "update:visible": function($event) {
        _vm.showBbr = $event
      },
      "close": function($event) {
        _vm.showBbr = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showMehrereBearbeiten) ? _c('dialogKontaktEditMultiple', {
    attrs: {
      "visible": _vm.showMehrereBearbeiten,
      "selectedKontakte": _vm.selected
    },
    on: {
      "update:visible": function($event) {
        _vm.showMehrereBearbeiten = $event
      },
      "close": function($event) {
        _vm.showMehrereBearbeiten = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showPrintDialog) ? _c('v-dialog', {
    attrs: {
      "width": "80%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showPrintDialog),
      callback: function($$v) {
        _vm.showPrintDialog = $$v
      },
      expression: "showPrintDialog"
    }
  }, [_c('v-card', {
    attrs: {
      "min-height": "600px"
    }
  }, [_c('v-card-title', [_vm._v("\n          Druck vorbereiten\n          "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showPrintDialog = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "pb-0"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_vm._v("\n              Welche Kontakte sollen gedruckt werden?\n              "), _c('v-radio-group', {
    model: {
      value: (_vm.printData.radioKontakte),
      callback: function($$v) {
        _vm.$set(_vm.printData, "radioKontakte", $$v)
      },
      expression: "printData.radioKontakte"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": 'Alle Ausgewählten Kontakte (' + _vm.selected.length + ')',
      "value": "allSelected"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "value": "allStatus"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_vm._v("\n                    Kontakte nach Status"), _c('v-select', {
          staticClass: "ml-2",
          attrs: {
            "dense": "",
            "single-line": "",
            "outlined": "",
            "hide-details": "",
            "small-chips": "",
            "chips": "",
            "clearable": "",
            "deletable-chips": "",
            "multiple": "",
            "items": _vm.itemsStatus,
            "label": "Hier auswählen"
          },
          model: {
            value: (_vm.printData.gruppen),
            callback: function($$v) {
              _vm.$set(_vm.printData, "gruppen", $$v)
            },
            expression: "printData.gruppen"
          }
        })]
      },
      proxy: true
    }], null, false, 919719247)
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": 'Alle ' + _vm.bezMitglieder,
      "value": "allBbrBbr"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Alle Kontakte",
      "value": "all"
    }
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_vm._v("\n              Was willst du drucken?\n              "), _c('v-radio-group', {
    model: {
      value: (_vm.printData.druckelement),
      callback: function($$v) {
        _vm.$set(_vm.printData, "druckelement", $$v)
      },
      expression: "printData.druckelement"
    }
  }, [_c('v-radio', {
    attrs: {
      "value": "mitgliederverzeichnis"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('v-list', {
          staticClass: "py-0",
          attrs: {
            "dense": ""
          }
        }, [_c('v-list-item', {
          attrs: {
            "link": ""
          }
        }, [_c('v-list-item-content', {
          staticClass: "py-0"
        }, [_c('v-list-item-title', [_vm._v("Mitgliederverzeichnis ")]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v("Geburtstagsliste und Kontaktdaten")]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v("PDF, A5")])], 1)], 1)], 1)]
      },
      proxy: true
    }], null, false, 4041911693)
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "value": "geburtstagsliste"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('v-list', {
          staticClass: "py-0",
          attrs: {
            "dense": ""
          }
        }, [_c('v-list-item', {
          attrs: {
            "link": ""
          }
        }, [_c('v-list-item-content', {
          staticClass: "py-0"
        }, [_c('v-list-item-title', [_vm._v("Geburtstagsliste")]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v("Geburtstagsliste, zwei Dateien für Sommer- und Wintersemester")]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v("PDF, A4")])], 1)], 1)], 1)]
      },
      proxy: true
    }], null, false, 1235835220)
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "value": "versandadressendina4"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('v-list', {
          staticClass: "py-0",
          attrs: {
            "dense": ""
          }
        }, [_c('v-list-item', {
          attrs: {
            "link": ""
          }
        }, [_c('v-list-item-content', {
          staticClass: "py-0"
        }, [_c('v-list-item-title', [_vm._v("Versandadressen DIN A4")]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v("Briefumschlaf DIN A4 mit Fenster")]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v("PDF A4, jeweils 1 Adresse pro Blatt")])], 1)], 1)], 1)]
      },
      proxy: true
    }], null, false, 662733520)
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "value": "versandadressendina4mitAnschreiben"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('v-list', {
          staticClass: "py-0",
          attrs: {
            "dense": ""
          }
        }, [_c('v-list-item', {
          attrs: {
            "link": ""
          }
        }, [_c('v-list-item-content', {
          staticClass: "py-0"
        }, [_c('v-list-item-title', [_vm._v("Versandadressen DIN A4 mit Anschreiben")]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v("Briefumschlaf DIN A4 mit Fenster")]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v("PDF A4, jeweils 1 Adresse pro Blatt, dadrunter Anschreiben")]), _vm._v(" "), (_vm.printData.druckelement === 'versandadressendina4mitAnschreiben') ? _c('v-btn', {
          staticClass: "my-2",
          attrs: {
            "outlined": "",
            "small": ""
          },
          on: {
            "click": function($event) {
              _vm.showAnschreiben = true
            }
          }
        }, [_vm._v("Anschreiben bearbeiten")]) : _vm._e()], 1)], 1)], 1)]
      },
      proxy: true
    }], null, false, 887961730)
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "value": "versandadressendinlang"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('v-list', {
          staticClass: "py-0",
          attrs: {
            "dense": ""
          }
        }, [_c('v-list-item', {
          attrs: {
            "link": ""
          }
        }, [_c('v-list-item-content', {
          staticClass: "py-0"
        }, [_c('v-list-item-title', [_vm._v("Versandadressen DIN Lang")]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v("Briefumschlaf DIN Lang mit Fenster")]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v("PDF A4, jeweils 3 Adressen pro Blatt")])], 1)], 1)], 1)]
      },
      proxy: true
    }], null, false, 1810279868)
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', {
    staticClass: "mb-6 mb-md-0"
  }, [_c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showPrintDialog = false
      }
    }
  }, [_vm._v("Abbrechen")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "text": "",
      "loading": _vm.$vars.loading,
      "disabled": _vm.printData.radioKontakte === undefined || _vm.printData.druckelement === undefined
    },
    on: {
      "click": function($event) {
        return _vm.print()
      }
    }
  }, [_vm._v("PDF erstellen")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showAnschreiben) ? _c('v-dialog', {
    attrs: {
      "width": "90%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showAnschreiben),
      callback: function($$v) {
        _vm.showAnschreiben = $$v
      },
      expression: "showAnschreiben"
    }
  }, [_c('v-card', {
    attrs: {
      "min-height": "500px"
    }
  }, [_c('v-card-title', [_vm._v("\n          Anschreiben bearbeiten\n          "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showAnschreiben = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-text-field', {
    staticClass: "pa-2",
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "",
      "placeholder": "Titel eingeben"
    },
    model: {
      value: (_vm.printData.anschreibenTitel),
      callback: function($$v) {
        _vm.$set(_vm.printData, "anschreibenTitel", $$v)
      },
      expression: "printData.anschreibenTitel"
    }
  }), _vm._v(" "), _c('v-textarea', {
    staticClass: "pa-2",
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "",
      "rows": "15",
      "placeholder": "Anschreiben eingeben"
    },
    model: {
      value: (_vm.printData.anschreiben),
      callback: function($$v) {
        _vm.$set(_vm.printData, "anschreiben", $$v)
      },
      expression: "printData.anschreiben"
    }
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showAnschreiben = false
      }
    }
  }, [_vm._v("Speichern")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showAenderungen) ? _c('v-dialog', {
    attrs: {
      "width": "90%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showAenderungen),
      callback: function($$v) {
        _vm.showAenderungen = $$v
      },
      expression: "showAenderungen"
    }
  }, [_c('v-card', {
    attrs: {
      "min-height": "500px"
    }
  }, [_c('v-card-title', [_vm._v("\n          Änderungen an den Mitgliederdaten\n          "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showAenderungen = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-tabs', {
    attrs: {
      "centered": "",
      "center-active": ""
    },
    model: {
      value: (_vm.jahrSelect),
      callback: function($$v) {
        _vm.jahrSelect = $$v
      },
      expression: "jahrSelect"
    }
  }, _vm._l((_vm.jahre), function(jahr, index) {
    return _c('v-tab', {
      key: index
    }, [_vm._v("\n            " + _vm._s(jahr) + "\n          ")])
  }), 1), _vm._v(" "), _c('v-tabs', {
    attrs: {
      "grow": ""
    },
    model: {
      value: (_vm.monatSelect),
      callback: function($$v) {
        _vm.monatSelect = $$v
      },
      expression: "monatSelect"
    }
  }, _vm._l((_vm.monate), function(monat, index) {
    return _c('v-tab', {
      key: index
    }, [_vm._v("\n            " + _vm._s(_vm.$filters.date(_vm.jahre[_vm.jahrSelect] + "-" + monat, "MM")) + "\n          ")])
  }), 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-simple-table', {
    attrs: {
      "dense": "",
      "fixed-header": "",
      "height": "calc(90vh - 266px)"
    }
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Geänderter Kontakt")]), _vm._v(" "), _c('th', [_vm._v("Geändert durch")]), _vm._v(" "), _c('th', [_vm._v("Geändert am")]), _vm._v(" "), _c('th', [_vm._v("Geänderte Felder")])])]), _vm._v(" "), _c('tbody', [_c('tr', [(_vm.bearbeitungen[_vm.jahre[_vm.jahrSelect]][_vm.monate[_vm.monatSelect]] === undefined) ? _c('td', {
    staticClass: "py-3 text-center",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("\n                  Im " + _vm._s(_vm.$filters.date(_vm.jahre[_vm.jahrSelect] + "-" + _vm.monate[_vm.monatSelect], "MMMM YYYY")) + " wurden keine\n                  Änderungen vorgenommen.\n                ")]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.bearbeitungen[_vm.jahre[_vm.jahrSelect]][_vm.monate[_vm.monatSelect]]), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      attrs: {
        "width": "20px"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$filters.user(item.elementId, _vm.bbrbbr2)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$filters.user(item.dataNeu.zuletztGeaendertVon, _vm.bbrbbr2)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$filters.date(item.dataNeu.zuletztGeaendertAm, "DD.MM.YYYY hh:mm")) + " Uhr")]), _vm._v(" "), _c('td', _vm._l((item.anders), function(item2, index2) {
      return _c('v-tooltip', {
        key: item2,
        attrs: {
          "bottom": ""
        },
        scopedSlots: _vm._u([{
          key: "activator",
          fn: function(ref) {
            var on = ref.on;

            return [_c('v-chip', _vm._g({
              attrs: {
                "small": ""
              }
            }, on), [_vm._v(_vm._s(item2))])]
          }
        }], null, true)
      }, [_vm._v(" "), _c('v-simple-table', {
        staticClass: "transparent",
        attrs: {
          "dense": "",
          "dark": ""
        }
      }, [_c('thead', [_c('tr', [_c('th', [_vm._v("von")]), _vm._v(" "), _c('th', [_vm._v("zu")])])]), _vm._v(" "), _c('tbody', [_c('tr', [(item.dataAlt[item2] instanceof Object) ? _c('td', _vm._l((item.dataAlt[item2]), function(text, index2) {
        return _c('div', {
          key: index2
        }, [_c('v-chip', {
          staticClass: "mt-1",
          attrs: {
            "label": "",
            "small": ""
          }
        }, [_vm._v("\n                                " + _vm._s(text) + "\n                              ")])], 1)
      }), 0) : _c('td', [_vm._v(_vm._s(item.dataAlt[item2] ? item.dataAlt[item2] : "-"))]), _vm._v(" "), (item.dataNeu[item2] instanceof Object) ? _c('td', _vm._l((item.dataNeu[item2]), function(text, index3) {
        return _c('div', {
          key: index3
        }, [_c('v-chip', {
          staticClass: "mt-1",
          attrs: {
            "label": "",
            "small": ""
          }
        }, [_vm._v("\n                                " + _vm._s(text) + "\n                              ")])], 1)
      }), 0) : _c('td', [_vm._v(_vm._s(item.dataNeu[item2] ? item.dataNeu[item2] : "-"))])])])])], 1)
    }), 1)])
  })], 2)])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showAenderungen = false
      }
    }
  }, [_vm._v("Schließen")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showFilterSpalten) ? _c('v-dialog', {
    attrs: {
      "width": "40%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showFilterSpalten),
      callback: function($$v) {
        _vm.showFilterSpalten = $$v
      },
      expression: "showFilterSpalten"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v("\n          Spalten bearbeiten\n          "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showFilterSpalten = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('v-autocomplete', {
    staticClass: "mt-2",
    attrs: {
      "chips": "",
      "deletable-chips": "",
      "small-chips": "",
      "hide-details": "",
      "outlined": "",
      "multiple": "",
      "dense": "",
      "label": "Spalten auswählen",
      "items": _vm.kontaktfelder_system
    },
    on: {
      "change": _vm.savereihenfolge
    },
    model: {
      value: (_vm.selectHeaders),
      callback: function($$v) {
        _vm.selectHeaders = $$v
      },
      expression: "selectHeaders"
    }
  }), _vm._v(" "), _c('v-list', [_c('draggable', {
    on: {
      "change": _vm.savereihenfolge
    },
    model: {
      value: (_vm.selectHeaders),
      callback: function($$v) {
        _vm.selectHeaders = $$v
      },
      expression: "selectHeaders"
    }
  }, _vm._l((_vm.selectHeaders), function(item, index) {
    return _c('v-list-item', {
      key: index,
      staticClass: "py-0"
    }, [_c('v-list-item-action', {
      staticClass: "my-0"
    }, [_c('v-icon', {
      staticClass: "grey--text"
    }, [_vm._v("drag_indicator")])], 1), _vm._v(" "), _c('v-list-item-content', {
      staticClass: "my-0"
    }, [_c('v-list-item-title', [_vm._v(_vm._s(_vm.kontaktfelder_system.find(function (feld) { return feld.value === item; }).text))])], 1)], 1)
  }), 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showFilterSpalten = false
      }
    }
  }, [_vm._v("Schließen")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showUpdate) ? _c('v-dialog', {
    attrs: {
      "width": "40%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showUpdate),
      callback: function($$v) {
        _vm.showUpdate = $$v
      },
      expression: "showUpdate"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v(" Kontakte updaten ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "mt-4"
  }, [_c('v-progress-linear', {
    attrs: {
      "stream": "",
      "rounded": "",
      "height": "24",
      "value": (_vm.updatedItems / _vm.allItems) * 100
    }
  }, [_vm._v("\n            " + _vm._s(_vm.updatedItems) + " von " + _vm._s(_vm.allItems) + "\n          ")]), _vm._v(" "), (_vm.updateData.error.length > 0) ? _c('v-alert', {
    attrs: {
      "type": "warning"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.updateData.error) + "\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showUpdate = false
      }
    }
  }, [_vm._v("Schließen")])], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3034763f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/kontakte.vue
// module id = 753
// module chunks = 15